import React from 'react';
import { Section } from '../Section';
import { Heading2 } from '../Heading2';
import { FadeUp } from '../FadeUp';
import { deliveryItems } from '../../data/inside';
export function Delivery() {
  return <Section data-id="element-104" data-mp="26s308vykwp3f">
      <FadeUp data-id="element-105" data-mp="26te1ao0n3iqu">
        <Heading2 data-id="element-106" data-mp="26svy17fk849f">Everything lives in your own private library</Heading2>

        <ul className="mx-auto mt-10 max-w-[480px] space-y-4" data-id="element-107" data-mp="2bqeav8wp73mp">
          {deliveryItems.map(item => <li key={item.lead} className="flex items-start gap-3 text-left text-[16px]" data-id="element-108" data-mp="1e4qcwjklgd92">
              <span aria-hidden="true" className="flex-none leading-[1.6] text-gain" data-id="element-109" data-mp="1j208kgyktl5c">
                ✓
              </span>
              <span data-id="element-110" data-mp="1o0a97732ldyc">
                <strong className="font-extrabold" data-id="element-111" data-mp="1nzs3ljuipndr">{item.lead}</strong>
                {item.rest}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-[480px] text-center text-[15px] text-ink/75" data-id="element-112" data-mp="vc5ww2pzu2mo">
          Instant access by email — nothing ships, nothing to wait for. Pay once, print it tonight,
          and print it again every time you need it.
        </p>
      </FadeUp>
    </Section>;
}